import type { DogBreederApplicationStatus, DogBreederLastConnectedTypeEnum } from '@gql/graphql';
import type { LabelTheme } from '@presentation/components';
import type { ReactNode } from 'react';
import { TbActivity, TbBolt, TbClock } from 'react-icons/tb';
import {
  placeholder,
  placeholderDog,
  placeholderShelter,
  placeholderUser,
  placeholderVideo,
} from './assets';

export const PLACEHOLDER_IMAGE = placeholder;
export const PLACEHOLDER_IMAGE_USER = placeholderUser;
export const PLACEHOLDER_IMAGE_DOG = placeholderDog;
export const PLACEHOLDER_IMAGE_SHELTER = placeholderShelter;
export const PLACEHOLDER_IMAGE_VIDEO = placeholderVideo;

export const COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE: Record<
  DogBreederLastConnectedTypeEnum,
  'blue' | 'lightBlue' | 'medium'
> = {
  VERY_ACTIVE: 'blue',
  ACTIVE: 'lightBlue',
  INACTIVE: 'medium',
};

export const ICON_PER_DOG_BREEDER_LAST_CONNECTED_TYPE: Record<
  DogBreederLastConnectedTypeEnum,
  ReactNode
> = {
  VERY_ACTIVE: <TbBolt fill="white" size="18px" />,
  ACTIVE: <TbActivity size="18px" />,
  INACTIVE: <TbClock size="18px" />,
};

export const COLOR_PER_DOG_BREEDER_APPLICATION_STATUS: Record<
  DogBreederApplicationStatus,
  LabelTheme
> = {
  NONE: 'medium',
  WAITING: 'blue',
  DONE: 'green',
  ACCEPTED: 'yellow',
  REJECTED: 'red',
  CANCELED: 'purple',
  EXPIRED: 'purple',
  REFUNDED: 'purple',
  WAITING_LIST: 'purple',
};
